import { Locale } from "./Locale";
import en from "./dictionaries/en";
import ru from "./dictionaries/ru";
export const languages = {
    en,
    ru,
};
export function createLocaleInstance() {
    return new Locale();
}
